import {
  Component,
  Input,
  OnInit,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { SnackbarService } from '../../../common/services/snackbar.service';
import { Constants } from '../../../common/utilities/constants.config';
import { ConsultantModel } from '../../../common/models/consultant.model';
import { FlagEntryModel } from '../../../common/models/flag-entry.model';
import { FlagEntryService } from '../../../common/services/flag-entry.service';
import { UserModel } from '../../../common/models/user.model';
import { getCurrentUser } from 'app/core/store/currentUser/user.selectors';
import { getLoggedInUser } from 'app/core/store/loggedInUser/loggedInUser.selectors';
import { Store } from '@ngrx/store';
import { getFlagReminderMsg } from 'app/core/store/flagReminderMsg/flagReminderMsg.selectors';
import { DateUtility } from '../../../common/utilities/date.utility';
import { WriteSilenceService } from '../../../common/services/write-silence.service';
import { formatDate } from '@angular/common';
import { error } from 'console';
import { Router } from '@angular/router';
import { URLPaths } from 'app/core/mips/common/utilities/urlPaths.config';
import { LocalStorageService } from 'app/core/mips/common/services/local-storage.service';
import { SustainabilityFlagService } from 'app/core/mips/common/services/sustainability-flag.service';
import { SustainabilityEntryService } from 'app/core/mips/common/services/sustainability-entry.service';
@Component({
  selector: 'app-flag-container',
  templateUrl: './flag-container.component.html',
  styleUrls: ['./flag-container.component.scss'],
})
export class FlagContainerComponent implements OnInit {
  @Input() card: any;
  @Input() matOptionsValue: any;
  @Input() checkFlagDeadline: any;
  @ViewChild('weekFlag', {static:true}) weekFlag!: TemplateRef<any>;
  @ViewChild('monthFlag', {static:true}) monthFlag!: TemplateRef<any>;
  @ViewChild('notifications', {static:true}) notifications!: TemplateRef<any>;
  @ViewChild('sustainabilityFlag', { static: true }) sustainabilityFlag!: TemplateRef<any>;

  isWeekMode: boolean;
  weekStartDate: any;
  weekEndDate: any;
  monthStartDate: any;
  monthEndDate: any;
  changeSummaryData = false;
  getTimeStartDate: any;
  getTimeEndDate: any;
  options: any = [];
  selected: any;
  flagEntryParams: FlagEntryModel = new FlagEntryModel();
  currentUser: ConsultantModel;
  loggedInUser: UserModel;
  flagReminderMsg: string | null;
  tempDisableBtn: boolean = false;
  employeeId : string;
  
  isWriteSilence: boolean;
  sustainabilityDropdownOptions=[];
  selectedSustainabilityOption: string = '';
  isFlagSubmitted = false;
  hasSustainabilityEntries = false;
  sustainabilityData: any[] = [];


  /**
   * Constructor
   */
  constructor(
    private _snackBarService: SnackbarService,
    private _flagEntryService: FlagEntryService,
    private _store: Store,
    private _writeSilenceService: WriteSilenceService,
    private _router: Router,
    private sustainabilityFlagService: SustainabilityFlagService,
    private sustainabilityService: SustainabilityEntryService
  ) {
        this._store.select(getCurrentUser).subscribe((data) => {
      this.currentUser = data;
      this.employeeId = this.currentUser.LoginName;
    });
    this._store.select(getLoggedInUser).subscribe((data) => {
      this.loggedInUser = data;
    });
    this._flagEntryService
      .getIsWeekMode()
      .subscribe((data) => (this.isWeekMode = data));
    this._flagEntryService.getSummaryDateRange().subscribe((data) => {
      (this.weekStartDate = data.weekStartDate),
        (this.weekEndDate = data.weekEndDate),
        (this.monthStartDate = data.monthStartDate),
        (this.monthEndDate = data.monthEndDate);
    });
    this._store.select(getFlagReminderMsg).subscribe((data) => {
      this.flagReminderMsg = data;
    });
    
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Lifecycle hooks
  // -----------------------------------------------------------------------------------------------------
  /**
   * On init
   */
ngOnInit() {
  this._writeSilenceService.writeSilence.subscribe((data) => {
    this.isWriteSilence = data;
  });

  switch (this.card['id']) {
    case 'weekFlag':
      for (let week of this.matOptionsValue['weeks']) {
        this.options.push(week['dateRange']);
      }
      this.selected = this.matOptionsValue['selectedWeek']['dateRange'];
      break;

    case 'monthFlag':
      for (let month of this.matOptionsValue['months']) {
        this.options.push(month['monthRange']);
      }
      this.selected = this.matOptionsValue['selectedMonth']['monthRange'];
      break;

    case 'sustainabilityFlag':
      this.populateSustainabilityDropdown();
      this.checkIfFlagSubmitted();
      break;
  }
}
private populateSustainabilityDropdown(): void {
  const today = new Date();
  const currentMonth = today.getMonth(); // 0–11
  const currentYear = today.getFullYear();

  let previousMonth: number;
  let previousYear: number;

  if (currentMonth === 0) { 
    previousMonth = 11;
    previousYear = currentYear - 1;
  } else {
    previousMonth = currentMonth - 1;
    previousYear = currentYear;
  }

  const monthNames = ["Jan","Feb","Mar","Apr","May","Jun",
                      "Jul","Aug","Sep","Oct","Nov","Dec"];

  const currentMonthName = monthNames[currentMonth];
  const previousMonthName = monthNames[previousMonth];

  this.sustainabilityDropdownOptions = [
    { label: `${currentMonthName} ${currentYear}`, value: `${currentMonthName}-${currentYear}` },
    { label: `${previousMonthName} ${previousYear}`, value: `${previousMonthName}-${previousYear}` }
  ];

  this.selectedSustainabilityOption = this.sustainabilityDropdownOptions[0].value;
}


onSubmitSustainabilityFlag(): void {
  if (!this.selectedSustainabilityOption) return;

  if (!this.hasSustainabilityEntries) {
    this._snackBarService.showSnackBar(
      'At least one sustainability entry is required to submit the flag.',
      null,
      'failure'
    );
    return;
  }

  if (this.isSelectedMonthPastDeadline()) {
    this._snackBarService.showSnackBar(
      this.getPastDeadlineMessage(),
      null,
      'failure'
    );
    return;
  }

  const selected = this.selectedSustainabilityOption; 
  const [monthName, year] = selected.split('-');
  const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
                      "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  const monthNumber = monthNames.indexOf(monthName) + 1;

  const timestamp = new Date().toISOString().slice(0, 19).replace('T', ' ');
  const mnumber = monthNumber.toString();

  this._snackBarService.showSnackBar(
    Constants.SNACKBAR_MSG_WAITING_FOR_API_RESPONSE,
    null,
    'info'
  );

  this.sustainabilityFlagService.postFlag(this.employeeId, mnumber, year, timestamp).subscribe({
    next: (response: any) => {
      this.isFlagSubmitted = true;
      this._snackBarService.showSnackBar(
        response?.['Message'] || response?.['message'] || 'Sustainability flag submitted successfully!',
        null,
        'success'
      );
      this.checkIfFlagSubmitted();
    },
    error: (err) => {
      console.error('Error saving flag', err);
      let errorMessage = err.statusText || 'Error submitting flag. Please try again.';
      if (err.error?.['Message']) {
        errorMessage += ' - ' + err.error['Message'];
      } else if (err.error?.['message']) {
        errorMessage = err.error['message'];
      } else if (err.error?.['detail']) {
        errorMessage += ' - ' + err.error['detail'];
      } else if (err.error?.['error']) {
        errorMessage = err.error['error'];
      }
      this._snackBarService.showSnackBar(errorMessage, 'close', 'failure');
    }
  });
}

private getPastDeadlineMessage(): string {
  const [monthName] = this.selectedSustainabilityOption.split('-');
  const monthNames = ["January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"];
  const selectedMonth = monthNames.find(month => month.startsWith(monthName)) || monthName;
  const selectedMonthNumber = monthNames.indexOf(selectedMonth) + 1;
  const deadline = new Date(Number(this.selectedSustainabilityOption.split('-')[1]), selectedMonthNumber, 15);
  const deadlineMonth = monthNames[deadline.getMonth()];

  return `The ${selectedMonth} flag cannot be submitted after ${deadlineMonth} 15.`;
}

isSelectedMonthPastDeadline(): boolean {
  if (!this.selectedSustainabilityOption) {
    return false;
  }

  const [monthName, year] = this.selectedSustainabilityOption.split('-');
  const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
    "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  const selectedMonth = monthNames.indexOf(monthName) + 1;
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const deadline = new Date(Number(year), selectedMonth, 15);
  deadline.setHours(0, 0, 0, 0);

  return today > deadline;
}

checkIfFlagSubmitted() {
  if (!this.selectedSustainabilityOption) {
    this.isFlagSubmitted = false;
    this.hasSustainabilityEntries = false;
    this.sustainabilityData = [];
    return;
  }

  const selected = this.selectedSustainabilityOption;  
  const [month, year] = selected.split('-');  
  const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
                      "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  const monthNumber = monthNames.indexOf(month) + 1;
  const paddedMonth = monthNumber.toString().padStart(2, '0');
  const mnumber = monthNumber.toString();
  const yearMonthStr = `${year}-${paddedMonth}`;

  this.sustainabilityFlagService
    .getSustainabilityFlag(this.employeeId, mnumber, year)
    .subscribe({
      next: (flagExists) => {
        this.isFlagSubmitted = flagExists;
        this.loadSustainabilityData(yearMonthStr, monthNumber, Number(year));
      },
      error: () => {
        this.isFlagSubmitted = false;
        this.loadSustainabilityData(yearMonthStr, monthNumber, Number(year));
      }
    });
}

private loadSustainabilityData(yearMonthStr: string, monthNumber: number, year: number): void {
  this.sustainabilityService
    .getSustainabilityData([yearMonthStr], this.employeeId)
    .subscribe({
      next: (data) => {
        const rawEntries = Array.isArray(data) ? data : [];
        const validEntries = rawEntries.filter(
          (entry: any) =>
            (!entry.travel_type_desc || entry.travel_type_desc === 'Daily') &&
            !entry.isCompletionRow &&
            !entry.isBlank &&
            Number(entry.month) === monthNumber &&
            Number(entry.year) === year
        );

        this.hasSustainabilityEntries = validEntries.length > 0;

        const displayed = [...validEntries];
        if (this.isFlagSubmitted) {
          const fullMonthNames = [
            "January", "February", "March", "April", "May", "June",
            "July", "August", "September", "October", "November", "December"
          ];
          const fullMonthName = fullMonthNames[monthNumber - 1] || monthNumber.toString();
          displayed.push({
            isCompletionRow: true,
            status: 'fetched',
            month: monthNumber,
            year: year,
            monthName: fullMonthName,
            employeeId: this.employeeId,
            message: `Sustainability Complete record  for ${fullMonthName} ${year}`,
            mode: `Sustainability Complete record  for ${fullMonthName} ${year}`,
            modeLabel: `Sustainability Complete record  for ${fullMonthName} ${year}`
          });
        }
        this.sustainabilityData = displayed;
      },
      error: (err) => {
        console.error('Error fetching sustainability data in flag container', err);
        this.hasSustainabilityEntries = false;
        this.sustainabilityData = [];
      }
    });
}

onFlagCompletionDeleted(event: any): void {
  const selected = this.selectedSustainabilityOption; 
  if (!selected) return;
  const [monthName, yearStr] = selected.split('-');
  const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
                      "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  const monthNumber = event?.month || (monthNames.indexOf(monthName) + 1);
  const year = event?.year || Number(yearStr);
  const employeeId = event?.employeeId || this.employeeId;

  this.sustainabilityFlagService.deleteFlag(employeeId, monthNumber, year).subscribe({
    next: (res) => {
      this.isFlagSubmitted = false;
      this._snackBarService.showSnackBar(
        res?.message || 'Sustainability flag completion record deleted successfully.',
        null,
        'success'
      );
      this.checkIfFlagSubmitted();
    },
    error: (err) => {
      console.error('Error deleting sustainability flag', err);
      this._snackBarService.showSnackBar(
        err.error?.error || err.error?.message || 'Error deleting sustainability flag. Please try again.',
        null,
        'failure'
      );
    }
  });
}

  onSelectChangeHandler(): void {
    const selectedvaluetostring = this.selected.toString();
    const dateFormat = new Date(selectedvaluetostring);
    if (this.card['id'] == 'weekFlag') {
      const week_partition = selectedvaluetostring.split(' - ');
      this.getTimeStartDate = week_partition[0];
      this.getTimeEndDate = week_partition[1];
      this._flagEntryService.setSummaryDateRange({
        weekStartDate: this.getTimeStartDate,
        weekEndDate: this.getTimeEndDate,
        monthStartDate: this.monthStartDate,
        monthEndDate: this.monthEndDate,
      });
      if (this.isWeekMode) {
        this.changeSummaryData = true;
      }
    } else if (this.card['id'] == 'monthFlag') {
      this.getTimeStartDate = DateUtility.formatDatefromDate(
        new Date(dateFormat.getFullYear(), dateFormat.getMonth(), 1)
      );
      this.getTimeEndDate = DateUtility.formatDatefromDate(
        new Date(dateFormat.getFullYear(), dateFormat.getMonth() + 1, 0)
      );
      this._flagEntryService.setSummaryDateRange({
        weekStartDate: this.weekStartDate,
        weekEndDate: this.weekEndDate,
        monthStartDate: this.getTimeStartDate,
        monthEndDate: this.getTimeEndDate,
      });
      if (!this.isWeekMode) {
        this.changeSummaryData = true;
      }
    }
    if (this.changeSummaryData) {
      this._snackBarService.showSnackBar(
        Constants.SNACKBAR_MSG_FLAG_SUMMARY_GRID_REFRESH,
        null,
        'info'
      );
      this._flagEntryService.getFlagTimeEntries(
        this.getTimeStartDate,
        this.getTimeEndDate,
        this.currentUser.Employee
      );
      this.changeSummaryData = false;
    }
  }

  flagClickHandler(flagMetric: string): void {
    switch (this.card['id']) {
      case 'weekFlag':
        this.flagEntryParams.flagPeriod = 'Week';
        this.flagEntryParams.entryDate = this.weekEndDate;
        this.flagEntryParams.startDate = this.weekStartDate;
        break;
      case 'monthFlag':
        this.flagEntryParams.flagPeriod = 'Month';
        this.flagEntryParams.entryDate = this.monthEndDate;
        this.flagEntryParams.startDate = this.monthStartDate;
        break;
    }
    const flagBtn = document.getElementById(this.flagEntryParams.flagPeriod + ' - ' + flagMetric);
    this.flagEntryParams.flagType = flagMetric;
    this.flagEntryParams.employee = this.currentUser.Employee;
    this.flagEntryParams.employeeMail = this.currentUser.Email;
    this.flagEntryParams.loginName = this.loggedInUser.username;
    this.flagEntryParams.CurrCode = 'GBP';
    this.tempDisableBtn = true;
    this._snackBarService.showSnackBar(
      Constants.SNACKBAR_MSG_WAITING_FOR_API_RESPONSE,
      null,
      'info'
    );
    this._flagEntryService.saveFlagEntry(this.flagEntryParams).subscribe(
      (response) => {
        if (response) {
          this._flagEntryService.getFlagEntry().subscribe((res) => {
            this.tempDisableBtn = false;
            this.checkFlagDeadline = res;
          });
          this._snackBarService.showSnackBar(
            response['Message'],
            null,
            response['Type']
          );
          if (this.card['id'] == 'monthFlag') {
            this._flagEntryService.monthFlagHitAnnounce();
          }
        }
      },
      (error) => {
        this.tempDisableBtn = false;
        let errorMessage = error.statusText;
        if (error.error['Message']) {
          errorMessage += ' - ' + error.error['Message'];
        } else if (error.error['detail']) {
          errorMessage += ' - ' + error.error['detail'];
        }
        this._snackBarService.showSnackBar(errorMessage, 'close', 'failure');
      }
    );
  }
  flagDisabledHandler(flagMetric: string): boolean {
    const formattedDateweekend = new Date(this.weekEndDate).toLocaleDateString(
      'en-CA'
    );
    const year = new Date(this.monthEndDate).getFullYear();
    const month = new Date(this.monthEndDate).getMonth() + 1;
    const formattedDatemonthend = `${year}|${month}`;

    switch (true) {
      case this.card['id'] === 'weekFlag' && flagMetric === 'Time':
        return (
          (this.checkFlagDeadline && this.checkFlagDeadline['periodWeekFlagMap']
            ? this.checkFlagDeadline['periodWeekFlagMap'].get(
                formattedDateweekend
              )['isTSFlagPresent']
            : false) || this.isWriteSilence
        );
      case this.card['id'] === 'weekFlag' && flagMetric === 'Expense':
        return (
          (this.checkFlagDeadline && this.checkFlagDeadline['periodWeekFlagMap']
            ? this.checkFlagDeadline['periodWeekFlagMap'].get(
                formattedDateweekend
              )['isEXFlagPresent']
            : false) || this.isWriteSilence
        );
      case this.card['id'] === 'monthFlag' && flagMetric === 'Time':
        return (
          (this.checkFlagDeadline &&
          this.checkFlagDeadline['periodMonthFlagMap']
            ? this.checkFlagDeadline['periodMonthFlagMap'].get(
                formattedDatemonthend
              )['isTSFlagPresent']
            : false) || this.isWriteSilence
        );
      case this.card['id'] === 'monthFlag' && flagMetric === 'Expense':
        return (
          (this.checkFlagDeadline &&
          this.checkFlagDeadline['periodMonthFlagMap']
            ? this.checkFlagDeadline['periodMonthFlagMap'].get(
                formattedDatemonthend
              )['isEXFlagPresent']
            : false) || this.isWriteSilence
        );
    }
  }
}
